// ligfrontend/src/components/Admin/JobsAdmin.jsx
import React, { useState, useEffect } from "react";
import { adminAPI } from "../../services/api";
import "./JobsAdmin.css";

const JobsAdmin = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("jobs");

  // Email preview states
  const [members, setMembers] = useState([]);
  const [previewData, setPreviewData] = useState({
    memberName: "",
    modelMember: "",
    email: "",
    nickName: "",
    inviterName: "",
  });
  const [previewHtml, setPreviewHtml] = useState("");
  const [previewMetadata, setPreviewMetadata] = useState(null);

  useEffect(() => {
    fetchStatus();
    fetchMembers();
  }, []);

  const fetchStatus = async () => {
    try {
      const response = await adminAPI.getJobStatus();
      console.log("fetchStatus", response);
      setStatus(response);
    } catch (error) {
      console.error("Error fetching job status:", error);
    }
  };

  const fetchMembers = async () => {
    try {
      const response = await adminAPI.getMembersList();
      console.log("fetchMembers", response);
      setMembers(response.members || []);
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const triggerJob = async (jobName) => {
    try {
      setLoading(true);
      await adminAPI.triggerJob(jobName);
      alert(`${jobName} job triggered successfully`);
      fetchStatus();
    } catch (error) {
      console.error(`Error triggering ${jobName}:`, error);
      alert(`Failed to trigger ${jobName} job`);
    } finally {
      setLoading(false);
    }
  };

  const handlePreviewNudge = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.previewNudgeEmail({
        memberName: previewData.memberName,
        modelMember: previewData.modelMember,
      });

      console.log("previewNudgeEmail", response);

      setPreviewHtml(response.html);
      setPreviewMetadata({
        subject: response.subject,
        to: response.to,
        from: response.from,
      });
    } catch (error) {
      console.error("Error previewing nudge email:", error);
      alert("Failed to preview nudge email");
    } finally {
      setLoading(false);
    }
  };

  const handlePreviewInvitation = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.previewInvitationEmail({
        email: previewData.email,
        nickName: previewData.nickName,
        inviterName: previewData.inviterName,
      });
      console.log("previewInvitationEmail", response);

      setPreviewHtml(response.html);
      setPreviewMetadata({
        subject: response.subject,
        to: response.to,
        from: response.from,
      });
    } catch (error) {
      console.error("Error previewing invitation email:", error);
      alert("Failed to preview invitation email");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setPreviewData((prev) => ({ ...prev, [field]: value }));
  };

  const clearPreview = () => {
    setPreviewHtml("");
    setPreviewMetadata(null);
  };

  return (
    <div className="jobs-admin-container">
      <div className="jobs-admin-header">
        <h1>Admin Panel</h1>
        <div className="tab-buttons">
          <button
            className={`tab-button ${activeTab === "jobs" ? "active" : ""}`}
            onClick={() => setActiveTab("jobs")}
          >
            Scheduled Jobs
          </button>
          <button
            className={`tab-button ${activeTab === "emails" ? "active" : ""}`}
            onClick={() => setActiveTab("emails")}
          >
            Email Previews
          </button>
        </div>
      </div>

      {activeTab === "jobs" && (
        <div className="jobs-section">
          <h2>Scheduled Jobs</h2>

          {status && (
            <>
              <div className="job-card">
                <h3>Reminder Job</h3>
                <div className="job-info">
                  <div className="info-row">
                    <span className="label">Status:</span>
                    <span
                      className={`status ${
                        status.reminder.scheduled ? "active" : "inactive"
                      }`}
                    >
                      {status.reminder.scheduled
                        ? "Scheduled"
                        : "Not Scheduled"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="label">Running:</span>
                    <span
                      className={`status ${
                        status.reminder.running ? "running" : "idle"
                      }`}
                    >
                      {status.reminder.running ? "Yes" : "No"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="label">Next Run:</span>
                    <span className="value">
                      {status.reminder.nextInvocation
                        ? new Date(
                            status.reminder.nextInvocation
                          ).toLocaleString()
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <button
                  className="btn-trigger"
                  onClick={() => triggerJob("reminder")}
                  disabled={loading || status.reminder.running}
                >
                  {status.reminder.running ? "Running..." : "Trigger Now"}
                </button>
              </div>

              <div className="job-card">
                <h3>True-up Job</h3>
                <div className="job-info">
                  <div className="info-row">
                    <span className="label">Status:</span>
                    <span
                      className={`status ${
                        status.trueUp.scheduled ? "active" : "inactive"
                      }`}
                    >
                      {status.trueUp.scheduled ? "Scheduled" : "Not Scheduled"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="label">Running:</span>
                    <span
                      className={`status ${
                        status.trueUp.running ? "running" : "idle"
                      }`}
                    >
                      {status.trueUp.running ? "Yes" : "No"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="label">Next Run:</span>
                    <span className="value">
                      {status.trueUp.nextInvocation
                        ? new Date(
                            status.trueUp.nextInvocation
                          ).toLocaleString()
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <button
                  className="btn-trigger"
                  onClick={() => triggerJob("trueup")}
                  disabled={loading || status.trueUp.running}
                >
                  {status.trueUp.running ? "Running..." : "Trigger Now"}
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {activeTab === "emails" && (
        <div className="emails-section">
          <h2>Email Previews</h2>

          <div className="preview-forms">
            <div className="preview-card">
              <h3>Nudge Email</h3>
              <div className="form-group">
                <label>Member Name</label>
                <select
                  value={previewData.memberName}
                  onChange={(e) =>
                    handleInputChange("memberName", e.target.value)
                  }
                  className="form-input"
                >
                  <option value="">Select a member...</option>
                  {members.map((member) => (
                    <option key={member._id} value={member.name}>
                      {member.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Model Member (Optional)</label>
                <input
                  type="text"
                  value={previewData.modelMember}
                  onChange={(e) =>
                    handleInputChange("modelMember", e.target.value)
                  }
                  placeholder="e.g., John, Sarah"
                  className="form-input"
                />
                <small>Names of members who posted today</small>
              </div>
              <button
                className="btn-preview"
                onClick={handlePreviewNudge}
                disabled={loading}
              >
                {loading ? "Loading..." : "Preview Nudge Email"}
              </button>
            </div>

            <div className="preview-card">
              <h3>Invitation Email</h3>
              <div className="form-group">
                <label>Recipient Email</label>
                <input
                  type="email"
                  value={previewData.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  placeholder="test@example.com"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>Nickname</label>
                <input
                  type="text"
                  value={previewData.nickName}
                  onChange={(e) =>
                    handleInputChange("nickName", e.target.value)
                  }
                  placeholder="Test User"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>Inviter Name</label>
                <input
                  type="text"
                  value={previewData.inviterName}
                  onChange={(e) =>
                    handleInputChange("inviterName", e.target.value)
                  }
                  placeholder="Your Name"
                  className="form-input"
                />
              </div>
              <button
                className="btn-preview"
                onClick={handlePreviewInvitation}
                disabled={loading}
              >
                {loading ? "Loading..." : "Preview Invitation Email"}
              </button>
            </div>
          </div>

          {previewMetadata && (
            <div className="email-preview">
              <div className="preview-header">
                <h3>Email Preview</h3>
                <button className="btn-close" onClick={clearPreview}>
                  ✕
                </button>
              </div>

              <div className="preview-metadata">
                <div className="metadata-row">
                  <strong>From:</strong> {previewMetadata.from}
                </div>
                <div className="metadata-row">
                  <strong>To:</strong> {previewMetadata.to}
                </div>
                <div className="metadata-row">
                  <strong>Subject:</strong> {previewMetadata.subject}
                </div>
              </div>

              <div className="preview-content">
                <iframe
                  srcDoc={previewHtml}
                  title="Email Preview"
                  className="email-iframe"
                  sandbox="allow-same-origin"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default JobsAdmin;
